module.exports = __webpack_public_path__ + "img/logo.e5fc35d6.png";